import { ManifestDeclarationResponse, ManifestDeclarationsResponse } from 'store/manifests/types';
import { DeclarationStatuses } from './enums/common/declaration-status';

export const AMENDABLE_DECLARATION_STATUSES: DeclarationStatuses[] = [
    DeclarationStatuses.REGISTERED,
    DeclarationStatuses.INSUFFICIENT_FUNDS,
    DeclarationStatuses.RELEASED,
];

export const EDITABLE_DECLARATION_STATUSES: DeclarationStatuses[] = [
    DeclarationStatuses.DRAFT,
    DeclarationStatuses.REJECTED,
    DeclarationStatuses.INVALID,
];

export const filterNonAmendableDeclaraitons = (
    declarations: ManifestDeclarationResponse[]
): ManifestDeclarationResponse[] => {
    return declarations.filter(
        (d) => !AMENDABLE_DECLARATION_STATUSES.includes(d.status) && !EDITABLE_DECLARATION_STATUSES.includes(d.status)
    );
};

export const getJobsWithNonAmendableDeclarations = (
    jobs: ManifestDeclarationsResponse[]
): ManifestDeclarationsResponse[] => {
    return jobs
        .map((job) => ({
            ...job,
            declarations: filterNonAmendableDeclaraitons(job.declarations),
        }))
        .filter((job) => job.declarations.length > 0);
};

/**
 * `meta` records where pre-filled values came from and is computed by the backend.
 * It is a big payload and rides along on the declaration we loaded,
 * so it has to be stripped before sending one back.
 */
export const withoutMeta = <T>(declaration: T): T => {
    const { meta, ...rest } = (declaration ?? {}) as T & { meta?: unknown };

    return rest as T;
};
